import { css } from '@emotion/core';

const styles = theme => ({
  badge: css`
    span&[class*='vds-badge'] {
      -ms-word-break: break-all;
      word-break: break-word;
    }

    // this is a work around until its fixed on the vds end 
    //will replace the new color once plugins is released 
    span&.vds-badge--status {
      fill: #021E4C;
      color: #021E4C;

      & svg.vds-icon,
      & svg.vds-icon use,
      & svg.vds-icon use path {
        fill: #021E4C;
      }
    }

    span&.vds-badge--warning {
      fill: #9B6603 !important;
      color: #9B6603;

      & svg.vds-icon,
      & svg.vds-icon use,
      & svg.vds-icon use path {
        fill: #9B6603 !important;
      }
    }

    span&.vds-badge--critical {
      color: #B3202A;
    }

    span&.vds-badge--stable {
      color: #2D6C4B;
    }

    span&.vds-badge--disabled {
      color: #021E4C;
    }

    svg.vds-icon {
      min-width: 1rem;
      min-height: 1rem;
    }
  `
});

export default styles;
